<template>
  <!--
      	作者：gmshop
      	时间：2020-06-25
      	描述：定制-定制设置
      -->
  <div class="product-add" v-if="!loading">
    <el-form size="small" ref="form" :model="form" label-width="160px">
      <!--会员折扣设置-->
      <div class="common-form mt50">会员酒体折扣设置</div>
      <el-form-item label="是否开启会员酒体折扣：">
        <el-radio-group v-model="form.is_grade">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="" v-if="form.is_grade ==1">
        <div class="max-w460">
          <el-table :data="gradeList" border size="mini" style="width: 100%">
            <el-table-column prop="name" label="会员等级">
            </el-table-column>
            <el-table-column prop="name" label="酒体折扣">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input v-model="scope.row.product_equity" type="number" placeholder="请输入酒体折扣"></el-input>
                  <span class="ml10">%</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
      <el-form-item label="是否开启会员酒体折扣差奖励：" v-if="form.is_grade ==1">
        <el-radio-group v-model="form.is_grade_discount">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
        <div class="gray9" v-if="form.is_grade_discount==0">关闭后用户下单时不计算会员折扣差奖励</div>
      </el-form-item>
      <div class="common-form">定制设置</div>
      <el-form-item label="是否开启定制: ">
        <el-radio-group v-model="form.is_customization">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="起订量: ">
          <el-input v-model="form.minimum_order_quantity" placeholder="请输入起订量" type="number" style="width: 200px;">
            <template slot="append">瓶</template>
          </el-input>
      </el-form-item>
      <el-form-item label="单次增加数量: ">
          <el-input v-model="form.inc_quantity" placeholder="请输入单次增加数量" type="number" style="width: 200px;">
            <template slot="append">瓶</template>
          </el-input>
      </el-form-item>
      <el-form-item label="分类说明: ">
          <el-input v-model="form.category_instructions" placeholder="请输入分类说明" type="text" style="width: 500px;"></el-input>
      </el-form-item>
      <el-form-item label="定制页:" v-if="!loading">
        <div class="edit_container">
          <Uediter :text="form.customization_content" id="ue3" @contentChange="customizationChangeFunc"></Uediter>
        </div>
      </el-form-item>
      <el-form-item label="酒体说明:" v-if="!loading">
        <div class="edit_container">
          <Uediter :text="form.agreement" id="ue2" @contentChange="agreementChangeFunc"></Uediter>
        </div>
      </el-form-item>
      <el-form-item label="定制协议:" v-if="!loading">
        <div class="edit_container">
          <Uediter :text="form.content" id="ue1" @contentChange="contentChangeFunc"></Uediter>
        </div>
      </el-form-item>


      <!--提交-->
      <div style="height: 100px;"></div>
      <div class="common-button-wrapper">
         <el-button type="primary" @click="onSubmit" :loading="loading">保存</el-button>
      </div>
    </el-form>

    <!--上传图片组件-->
    <Upload v-if="isStoreUpload" :config="{ total: 9 }" :isupload="isStoreUpload" @returnImgs="returnStoreImgsFunc">上传图片</Upload>
  </div>
</template>
<script>
  import CustomizationApi from '@/api/customization.js';
  import Uediter from '@/components/UE.vue';
  import Upload from '@/components/file/Upload';
  import draggable from 'vuedraggable';
  export default {
    components: {
      /*编辑器*/
      Uediter,
      Upload,
      draggable
    },
    data() {
      return {
        form: {
          is_customization: 0,
          minimum_order_quantity: 0,
          inc_quantity: 1,
          category_instructions: '',
          content: '',
          agreement: '',
          customization_content: '',
          /*是否开启会员折扣*/
          is_grade: 0,
          is_grade_discount: 0
        },
        /*会员等级*/
        gradeList: [],
        /*富文本框配置*/
        ueditor: {
          text: '',
          config: {
            initialFrameWidth: 400,
            initialFrameHeight: 500
          }
        },
        /*是否正在加载*/
        loading: true,
        /*是否上传图片*/
        isStoreUpload:false,


      };
    },
    created() {
      /*获取列表*/
      this.getSetting();
    },
    methods: {
      /*获取设置*/
      getSetting() {
        let self = this;
        let Params = {};
        CustomizationApi.getSetting(Params, true)
          .then(data => {
            self.form = data.data.customization;
            /*单独产品折扣*/
            if(self.form.alone_grade_equity!=null && typeof self.form.alone_grade_equity !='undefined'){
              let equitys=self.form.alone_grade_equity;
              data.data.gradeList.forEach(item=>{
                item.product_equity = equitys[item.grade_id];
              });
            }
            self.gradeList = data.data.gradeList;
            self.loading = false;
          })
          .catch(error => {});
      },
      /*获取富文本内容*/
      customizationChangeFunc(e){
        this.form.customization_content=e;
      },
      /*获取富文本内容*/
      contentChangeFunc(e){
        this.form.content=e;
      },
      /*获取富文本内容*/
      agreementChangeFunc(e){
        this.form.agreement=e;
      },
      /*点击保存*/
      onSubmit() {
        let self = this;
        let params = self.form;
        params.alone_grade_equity=self.convertJson(self.gradeList);
        self.loading = true;
        CustomizationApi.editSetting(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，保存成功',
                type: 'success'
              });
              self.getSetting();
            } else {
              self.loading = false;
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*转JSON字符串*/
      convertJson(list){
        let obj={};
        list.forEach(item=>{
          obj[item.grade_id]=item.product_equity;
        });
        return JSON.stringify(obj);
      },

      /*打开上传图片*/
      openStoreUpload: function() {
        this.isStoreUpload = true;
      },
      /*上传商品图片*/
      returnStoreImgsFunc(e) {
        if (e != null) {
          let imgs = [];
          if(this.form.image){
            imgs = this.form.image.concat(e);
          }else{
            imgs = e;
          }
          this.$set(this.form, 'image', imgs);
        }
        this.isStoreUpload = false;
      },

      /*删除商品图片*/
      deleteImg(index) {
        this.form.image.splice(index, 1);
      },
    }
  };
</script>

<style>
  .draggable-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .draggable-list .wrapper > span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
  }

  .draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }

  .draggable-list .item:hover .delete-btn {
    display: block;
  }

  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }

  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }

  .draggable-list .img-select i {
    color: #409eff;
  }
</style>



// WEBPACK FOOTER //
// src/views/customization/setting/index.vue